// ── Types & constants shared across PMJournal sub-components ──────────────────

export interface PMJournalHeaderType {
    projJournalTableEntityId?: string
    batchnumber?: string
    journalName: string
    projectId: string
    resourceId?: string
    dataAreaId?: string
    posted: boolean
    date: string
    isDeputyView?: boolean
    totalHours?: number
}

export interface PMJournalLineType {
    projJournalTransEntityId?: string
    journalid?: string
    projectId?: string
    activityNumber: string
    resourceId?: string
    dataAreaId?: string
    projectDate?: string
    hours: number
    linenumber?: number
    category?: string
    description?: string
    delete: boolean
}

export const YE_JOURNAL = 'YE_Hours'
export const AI_JOURNAL = 'AI_Hours'
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'

export type ListFilter = {
    journalId: string
    project: string
    type: string
    status: string
    role: string
}

export const EMPTY_FILTER: ListFilter = {
    journalId: '',
    project: '',
    type: '',
    status: '',
    role: '',
}
